import { BrowserRouter, Routes, Route } from "react-router-dom";
/*PAGINAS POR TOUR - MEDIO DIA*/
import Citytour from "./components/tour-tradicional/Citytour";
import MarasMoray from "./components/tour-tradicional/MarasMoray";
import ValleSur from "./components/tour-tradicional/ValleSur";
/**FIN PAGINAS POR TOUR MEDIO DIA */
/**PAGINAS TOUR TRADICIONAL - FULL DAY */
import ValleSagrado from "./components/tour-tradicional/ValleSagrado";
import ValleVip from "./components/tour-tradicional/ValleVip";
/** FIN PAGINAS POR TOUR TRADICIONAL - FULL DAY */
/**PAGINAS TREK FULL DAY */
import MontaniaColores from "./components/tour-tradicional/MontaniaColores";
import LagunaHuamantay from "./components/tour-tradicional/LagunaHuamantay";
import MontaniaPalcoyo from "./components/tour-tradicional/montaniaPalcoyo";
import Waqrapukara from "./components/tour-tradicional/Waqrapukara";
/**FIN PAGINAS TREK FULL DAY */
/**PAGINAS TOUR AVENTURA */
import CuatriMarasMoray from "./components/tour-tradicional/CuatriMarasMoray";
/**FIN PAGINAS TOUR AVENTURA */
/**PAGINAS TOUR TREK CAMINO INCA */
import Caminoinca1x2 from "./components/tour-trek/Caminoinca1x2";
/** FORMULARIOS DE TOUR */
import ReservarTour from "./components/reservar-tour/ReservarTour";
/** FIN FORMULARIOS DE TOUR */

import ScrollTop from "./components/common/ScrollTop";

import Home from "./components/home/Home";

import Nosotros from "./components/home/Nosotros";

import CustomPage from "./components/common/CustomPage";
import Caminoinca4x3 from "./components/tour-trek/Caminoinca4x3";
import SalkantayTrek5d from "./components/tour-trek/SalkantayTrek5d";
import SalkantayTrek4d from "./components/tour-trek/SalkantayTrek4d";
import Choquequirao4D from "./components/tour-trek/Choquequirao4D";


function App() {
  return (
    <>
      <BrowserRouter basename="/">
        <>
          <ScrollTop />

          <Routes>
            
            <Route
              exact
              path="/"
              element={<CustomPage component={<Home />} />}
            />
            /**MEDIO DIA */
            <Route
            exact
            path="/tour-tradicional/citytour"
            element={<CustomPage component={<Citytour/>}/>}
            />
            <Route
            exact
            path="/tour-tradicional/maras-moray"
            element={<CustomPage component={<MarasMoray/>}/>}
            />
            <Route
            exact path="/tour-tradicional/valle-sur"
            element={<CustomPage component={<ValleSur/>}/>}
            />
            /** FULL DAY */
            <Route
            exact path="/tour-tradicional/valle-sagrado"
            element={<CustomPage component={<ValleSagrado/>}/>}
            />
            <Route
            exact
            path="/tour-tradicional/valle-vip"
            element={<CustomPage component={<ValleVip/>}/>}
            />
            /**TOUR TREK */
            <Route exact path="/tour-tradicional/montania-colores"
            element={<CustomPage component={<MontaniaColores/>}/>}
            />
            <Route exact path="/tour-tradicional/montania-palcoyo"
            element={<CustomPage component={<MontaniaPalcoyo/>} />}
            />
            <Route exact path="/tour-tradicional/laguna-huamantay"
            element={<CustomPage component={<LagunaHuamantay/>}/>}
            />
            
            <Route exact path="/tour-tradicional/waqrapuka"
            element={<CustomPage component={<Waqrapukara/>}/>}
            />
            /** TOUR AVENTURA */
            <Route
            exact
            path="/tour-tradicional/cuatrimoto-maras-moray"
            element={<CustomPage component={<CuatriMarasMoray/>}/>}
            />
            <Route
              exact
              path="/reservar/tour" 
              element={<ReservarTour/>}/>

            <Route
              exact
              path="/nuestra-historia/nosotros"
              element={<CustomPage component={<Nosotros />} />}
            />
            /**TOUR TREK - CAMINO INCA */
            <Route
              exact
              path="/tour-trek/caminoinca2dx1n"
              element={<CustomPage component={<Caminoinca1x2 />} />}
            />
            <Route
              exact
              path="/tour-trek/caminoinca4dx3n"
              element={<CustomPage component={<Caminoinca4x3 />} />}
            />
            <Route
              exact
              path="/tour-trek/salkantayTrek5d"
              element={<CustomPage component={<SalkantayTrek5d />} />}
            />
            <Route
              exact
              path="/tour-trek/salkantayTrek4d"
              element={<CustomPage component={<SalkantayTrek4d />} />}
            />
            <Route
              exact
              path="/tour-trek/choquequirao4d"
              element={<CustomPage component={<Choquequirao4D />} />}
            />


            <Route
              path="*"
              element={
                <div>
                  <p>Error 404</p>
                </div>
              }
            />
          </Routes>
        </>
      </BrowserRouter>
    </>
  );
}

export default App;
